export default {
  pageHeroV1: {
    container: {
      height: '75vh',
      width: '100%',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      alignItems: 'flex-end',
      justifyContent: 'flex-start'
    },

    content: {
      flexDirection: 'column',
      color: 'white',
      textAlign: 'center',
      mb: '10vh',
      h1: {
        fontSize: ['2.5rem', '', '4.5rem'],
        marginBottom: 1,
        letterSpacing: '3px',
        borderColor: 'secondary',
        // backgroundColor: 'rgba(0,0,0,0.35)',
        fontFamily: 'display',
        fontWeight: 'normal',
        color: 'light',
        textShadow: '2px 2px 2px black',
        backgroundColor: 'rgb(29 33 68 / 84%)',
        padding: '1.5rem 3rem',
        borderBottom: '#5095b2 solid 8px'
      },
      h2: {
        marginBottom: 4
      }
    }
  }
}
